<template>
  <div>
    <table class="table table-sm color mb-2">
      <caption class="caption table-caption">ACIS Description</caption>
      <tbody>
        <tr>
          <th class="text-left font-weight-normal">Initial Limit ($)</th>
          <td class="text-right">
            <b-form-input id="ownedFaceAmt" v-model="ownedFaceAmt" class="calculation-settings-input" :formatter="formatUSD" lazy-formatter></b-form-input>
          </td>
        </tr>
        <tr>
          <th class="text-left font-weight-normal">Collateral (%)</th>
          <td class="text-right">
            <b-form-input id="margin" v-model="margin" class="calculation-settings-input"></b-form-input>
          </td>
        </tr>
        <tr>
          <th class="text-left font-weight-normal">Interest Rate (%)</th>
          <td class="text-right">
            <b-form-input id="interestRate" v-model="interestRate" class="calculation-settings-input"></b-form-input>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import formatter from "../../utilities/Formatter";

export default {
  props: ["inputOwnedFaceAmt", "inputMargin", "inputInterestRate"],

  computed: {
    ownedFaceAmt: {
      get: function () {
        return this.inputOwnedFaceAmt;
      },
      set: function (newVal) {
        this.$emit("ownedFaceAmtChange", newVal)
      }
    },
    margin: {
      get: function () {
        return this.inputMargin;
      },
      set: function (newVal) {
        this.$emit("marginChange", newVal)
      }
    },
    interestRate: {
      get: function () {
        return this.inputInterestRate;
      },
      set: function (newVal) {
        this.$emit("interestRateChange", newVal)
      }
    }
  },
  methods: {
    formatUSD: function(val, event) {
      return formatter.formatDollarValue(val)
    }
  }
}
</script>
